import { render, staticRenderFns } from "./UploadProductImageDialog.vue?vue&type=template&id=798cebe0&scoped=true"
import script from "@/views/Variants/UploadProductImageDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Variants/UploadProductImageDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Variants/upload-product-image-dialog.scss?vue&type=style&index=0&id=798cebe0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798cebe0",
  null
  
)

export default component.exports